export default {
  POINTS_DECIMAL_SEPARATOR: process.env.REACT_APP_POINTS_DECIMAL_SEPARATOR,
  REACT_APP_SYSTEM_MAX_LIMIT_SIZE_UPLOAD_ATTACHMENT_MB: process.env.REACT_APP_SYSTEM_MAX_LIMIT_SIZE_UPLOAD_ATTACHMENT_MB || 25,
};
